import { nf } from "../lib/format";

export interface BarListItem {
  key: string;
  label: string;
  value: number;
  extra?: number;
}

export function BarList({
  title,
  items,
  valueLabel = "Pengunjung",
  extraLabel,
}: {
  title: string;
  items: BarListItem[];
  valueLabel?: string;
  extraLabel?: string;
}) {
  const max = Math.max(1, ...items.map((item) => item.value));

  return (
    <section className="card p-4">
      <div className="mb-3 flex items-center justify-between gap-2">
        <h3 className="text-sm font-semibold text-slate-800">{title}</h3>
        <div className="flex gap-4 text-[11px] font-medium uppercase tracking-wide text-slate-400">
          {extraLabel && <span className="w-14 text-right">{extraLabel}</span>}
          <span className="w-14 text-right">{valueLabel}</span>
        </div>
      </div>
      {items.length === 0 ? (
        <p className="py-6 text-center text-sm text-slate-400">Tidak ada data</p>
      ) : (
        <ul className="space-y-0.5">
          {items.map((item) => (
            <li
              key={item.key}
              className="relative flex items-center justify-between gap-3 rounded-md px-2 py-1.5 text-sm"
            >
              <span
                className="absolute inset-y-0 left-0 rounded-md bg-emerald-50"
                style={{ width: `${Math.max(2, (item.value / max) * 100)}%` }}
              />
              <span className="relative truncate text-slate-700" title={item.label}>
                {item.label}
              </span>
              <span className="relative flex shrink-0 tabular-nums text-slate-500">
                {extraLabel && <span className="w-14 text-right">{nf.format(item.extra ?? 0)}</span>}
                <span className="w-14 text-right font-medium text-slate-800">{nf.format(item.value)}</span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
